import React, { useState, Fragment } from 'react';
import { observer } from 'mobx-react';
import ErrorMessage from '../../errormessage';
import ThemedEmailSentSVG from '../../themed/ThemedEmailSentSVG';
import {
    Heading1,
    Heading3,
    TextDefault,
    ThemedButton,
} from '@awarego-ui/components';

function PreviewEmail({ ownEmail, onRequestClose, sendPreview, sendError }) {
    const [previewSent, setpreviewSent] = useState(false);

    // should be deleted once backend works better..
    const previewType = 0;
    const selectedEvents = [];

    const onPreviewSend = () => {
        // The backend always sends the preview to the logged-in caller's own
        // verified email regardless of what's submitted here — kept in the
        // payload for backward compatibility with the API shape.
        sendPreview(ownEmail, previewType, selectedEvents);
        setpreviewSent(true);
    };

    return (
        <div className="modalWindow simple">
            <div className={'modalHeader plain'}>
                {!previewSent && <Heading1>Send a preview of emails</Heading1>}
                <img
                    className={'modal-close-right'}
                    src="/static/img/close.svg"
                    alt="Close"
                    onClick={onRequestClose}
                />
            </div>
            <ErrorMessage error={sendError} />
            {!previewSent ? (
                <Fragment>
                    <div
                        className={'modalContent'}
                        style={{ minHeight: '120px' }}
                    >
                        <div className="form-holder">
                            <TextDefault>
                                The preview will be sent to your email
                                address: <strong>{ownEmail}</strong>
                            </TextDefault>
                        </div>
                    </div>
                    <div className={'modalFooter'}>
                        <ThemedButton
                            mode="primary"
                            text="Send Preview"
                            onClick={onPreviewSend}
                        />
                    </div>
                </Fragment>
            ) : (
                <div className={'modalContent'}>
                    <div className="no-assessments-found">
                        <ThemedEmailSentSVG />
                        <div className="stats">
                            <Heading3 mt={16} mb={8} displayBlock>
                                Preview sent successfully
                            </Heading3>
                            <p>
                                The preview of this assessment was sent to{' '}
                                {ownEmail}
                            </p>
                        </div>
                        <ThemedButton
                            mode="primary"
                            text="Ok"
                            onClick={onRequestClose}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default observer(PreviewEmail);
